import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = ['dependent', 'trigger']

  connect() {
    this.update()
  }

  dependentTargetConnected(dependent) {
    this.update()
  }

  update() {
    const triggerValue = this.triggerTarget.value

    this.dependentTargets.forEach((element) => {
      const matchValue = element.dataset.formVisibleMatchValue
      if (triggerValue === matchValue) {
        element.classList.remove('hidden')
      } else {
        element.classList.add('hidden')
      }
    })
  }
}
